// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/vehicle/VehicleEntry"),
  iconType: "car",
  name: "vehicle",
  subApps: [
    {
      name: "overview"
    },
    {
      name: "reports",
      requirePermission: "vehicle:report-view"
    },
    {
      name: "import",
      requirePermission: "vehicle:create"
    }
  ]
}: AppType)
